import { Box, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import moment from 'moment'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { getHomeCourses } from '../../../../redux/actions/courses'
import { setFavorite, unsetFavorite } from '../../../../redux/actions/favorites'
import { IRootState } from '../../../../redux/types'
import FeedHeader from '../../styles/FeedHeader'
import ShareIcon from '../icons/ShareIcon'
import HomeCoursesFeedSkeleton from '../skeletons/HomeCoursesFeedSkeleton'
import CardHero from './CardHero'

function CoursesFeed() {
  const { t } = useTranslation(['global'])
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { homeCourses, feedCourses, loading: coursesLoading } = useSelector((state: IRootState) => state.course)
  const { globalCountryId, globalLanguageId } = useSelector((state: IRootState) => state.global)

  useEffect(() => {
    dispatch(
      getHomeCourses({
        country_id: globalCountryId,
        language_id: globalLanguageId
      })
    )
  }, [globalCountryId, globalLanguageId])

  const handleFavoriteClick = (id: number, type: string, inputField: string) => (state: boolean) => {
    if (state) {
      dispatch(
        setFavorite({
          id,
          state,
          type,
          favoritefield: inputField
        })
      )
    } else {
      dispatch(
        unsetFavorite({
          id,
          state,
          type: type,
          favoritefield: inputField
        })
      )
    }
  }

  return (
    <>
      {coursesLoading ? (
        <HomeCoursesFeedSkeleton />
      ) : (
        <>
          {feedCourses.length > 0 ? (
            <>
              {feedCourses.length > 0 && (
                <FeedHeader xs={12}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5">{t('Continue-learning')}</Typography>
                    <Typography
                      onClick={() => navigate(`/cursos`)}
                      color="textSecondary"
                      sx={{
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        '&:hover': {
                          color: 'primary.dark'
                        }
                      }}
                    >
                      {t('see-more')}
                    </Typography>
                  </Box>
                </FeedHeader>
              )}
              <Grid container spacing={2}>
                {feedCourses.map((feedCourse: any) => (
                  <Grid key={feedCourse.id} xs={12} md={6} lg={4}>
                    <CardHero
                      type={1}
                      redirect={`/cursos/${feedCourse.brand_id}/${feedCourse.slug}`}
                      cardBrandName={feedCourse.brandName}
                      cardVisibility={feedCourse.visibility}
                      cardImage={feedCourse.image_url}
                      cardTitle={feedCourse.title}
                      cardDescription={feedCourse.description}
                      cardDate={`${moment(feedCourse.created_at).fromNow()}`}
                      cardActions={
                        <ShareIcon
                          visibility={feedCourse.visibility}
                          title={feedCourse.title}
                          description={feedCourse.description}
                          link={`${window.location.origin}/cursos/${feedCourse.brand_id}/${feedCourse.slug}${window.location.search}`}
                          type="news"
                          multimedia={feedCourse.image_url}
                          buttonText={t('share')}
                        />
                      }
                      favoriteState={Boolean(feedCourse.favoriteId)}
                      onClickFavorite={handleFavoriteClick(feedCourse.id, 'course', 'feedCourses')}
                    />
                  </Grid>
                ))}
              </Grid>
            </>
          ) : (
            <>
              {homeCourses.length > 0 && (
                <FeedHeader xs={12}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5">{t('new-formations')}</Typography>
                    <Typography
                      onClick={() => {
                        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
                        navigate(`/cursos`)
                      }}
                      color="textSecondary"
                      style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    >
                      {t('see-more')}
                    </Typography>
                  </Box>
                </FeedHeader>
              )}
              <Grid container spacing={2}>
                {homeCourses.slice(0, 3).map((homeCourse: any) => (
                  <Grid key={homeCourse.id} xs={12} lg={4}>
                    <CardHero
                      type={1}
                      redirect={`/cursos/${homeCourse.brand_id}/${homeCourse.slug}`}
                      cardBrandName={homeCourse.brandName}
                      cardVisibility={homeCourse.visibility}
                      cardImage={homeCourse.image_url}
                      cardTitle={homeCourse.title}
                      cardDescription={homeCourse.description}
                      cardDate={`${moment(homeCourse.created_at).fromNow()}`}
                      cardActions={
                        <ShareIcon
                          visibility={homeCourse.visibility}
                          title={homeCourse.title}
                          description={homeCourse.description}
                          link={`${window.location.origin}/cursos/${homeCourse.brand_id}/${homeCourse.slug}${window.location.search}`}
                          type="news"
                          multimedia={homeCourse.image_url}
                          buttonText={t('share')}
                        />
                      }
                      favoriteState={Boolean(homeCourse.favoriteId)}
                      onClickFavorite={handleFavoriteClick(homeCourse.id, 'course', 'homeCourses')}
                    />
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        </>
      )}
    </>
  )
}

export default CoursesFeed
